import {forwardRef} from 'react'

export type IncludeFragmentProps = JSX.IntrinsicElements['include-fragment']

function IncludeFragmentWithRef({children, ...props}: IncludeFragmentProps, ref: React.Ref<HTMLElement>) {
  return (
    <include-fragment {...props} ref={ref}>
      {children}
    </include-fragment>
  )
}

export const IncludeFragment = forwardRef(IncludeFragmentWithRef)

try{ IncludeFragmentWithRef.displayName ||= 'IncludeFragmentWithRef' } catch {}
try{ IncludeFragment.displayName ||= 'IncludeFragment' } catch {}